export const CIRCLE_SIZE = 44
export const LINE_TOP = CIRCLE_SIZE / 2

export const rebateDetailModalStyles = {
  overlay: {
    position: "fixed",
    top: 0, right: 0, bottom: 0, left: 0,
    background: "rgba(0,0,0,0.55)",
    zIndex: 1000,
    display: "flex",
    justifyContent: "center",
  },
  sheet: {
    background: "#fff",
    padding: "28px 24px 40px",
    width: "100%",
    maxWidth: 560,
    maxHeight: "88vh",
    overflowY: "auto",
    position: "relative",
    boxShadow: "0 -4px 24px rgba(0,0,0,0.15)",
  },
  closeBtn: {
    position: "absolute",
    top: 16,
    right: 16,
    width: 32,
    height: 32,
    border: "none",
    background: "transparent",
    fontSize: "1rem",
    color: "#555",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
  },
  title: {
    fontSize: "1.3rem",
    fontWeight: 700,
    color: "#111",
    marginBottom: 28,
    marginTop: 4,
    paddingRight: 32,
  },
  tracker: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    position: "relative",
    marginBottom: 28,
  },
  trackerLineBg: {
    position: "absolute",
    top: LINE_TOP,
    left: CIRCLE_SIZE / 2,
    right: CIRCLE_SIZE / 2,
    height: 2,
    background: "#e9e9e9",
  },
  trackerLineProgress: {
    position: "absolute",
    top: LINE_TOP,
    left: CIRCLE_SIZE / 2,
    height: 2,
    background: "#1a1a1a",
    transition: "width 0.3s",
  },
  step: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 8,
    width: CIRCLE_SIZE,
    zIndex: 1,
  },
  stepCircle: {
    width: CIRCLE_SIZE,
    height: CIRCLE_SIZE,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  stepLabel: {
    fontSize: "0.75rem",
    textAlign: "center",
    whiteSpace: "nowrap",
  },
  message: {
    fontSize: "0.9rem",
    color: "#444",
    marginBottom: 28,
    lineHeight: 1.5,
  },
  approvedCallout: {
    display: "flex",
    alignItems: "flex-start",
    gap: 10,
    padding: "12px 14px",
    borderRadius: 8,
    background: "#d4f5d8",
    marginTop: 28,
    fontSize: "0.9rem",
    color: "#1a1a1a",
    lineHeight: 1.4,
  },
  approvedCalloutIcon: {
    flexShrink: 0,
    marginTop: 1,
  },
  errorList: {
    margin: "-16px 0 28px 0",
    paddingLeft: 20,
    fontSize: "0.9rem",
    color: "#444",
    lineHeight: 1.5,
  },
  errorItem: {
    marginBottom: 4,
  },
  supportText: {
    fontSize: "0.9rem",
    color: "#444",
    marginBottom: 28,
    lineHeight: 1.5,
  },
  supportLink: {
    color: "#e20074",
    textDecoration: "underline",
  },
  details: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
  },
  detailRow: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  detailLabel: {
    fontSize: "0.8rem",
    color: "#777",
  },
  detailValue: {
    fontSize: "0.95rem",
    fontWeight: 700,
    color: "#111",
  },
  rewardBtn: {
    display: "block",
    width: "100%",
    marginTop: 28,
    padding: "16px",
    background: "#e20074",
    color: "#fff",
    border: "none",
    borderRadius: 4,
    fontSize: "1rem",
    fontWeight: 700,
    cursor: "pointer",
    textAlign: "center",
  },
}
